import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CommonTableGraph from '../../../../charts/CommonTableGraph';
const PositionHistoryTable = ({ posHistory = [] }) => {
    let tableFormat = posHistory.map((row) => {
        return {
            Latitude: row.position.lat,
            Longitude: row.position.lng,
            _Time: row.timestamp,
        };
    });
    if (tableFormat.length === 0)
        tableFormat = [{ Location: 'Location not found', _Time: undefined }];
    return _jsx(CommonTableGraph, { data: tableFormat });
};
export default PositionHistoryTable;
